export default "__VITE_ASSET__B0prBkp7__"